import { useState, useEffect } from 'react';
import config from '../config';
export default function useSelectedStatus(status) {
  const [selectedStatus, setSelectedStatus] = useState();

  useEffect(() => {
    if (status) {
      setSelectedStatus(status);
    }
  }, [status]);

  const handleStatusChange = (statusKey) => {
    setSelectedStatus(config.statusByKey[statusKey]);
  };

  return [selectedStatus, handleStatusChange];
}
